import { User, UserRole } from '../generated/gql-types';

type UserStoreSnapshot = {
  currentUser: User | null;
  impersonatedUserId: string | null;
};

let readUserStore: (() => UserStoreSnapshot) | null = null;

/** Called once when the user store module initialises (avoids apollo ↔ store import cycle). */
export const setUserStoreReader = (reader: () => UserStoreSnapshot): void => {
  readUserStore = reader;
};

export const readCurrentUserRole = (): UserRole | null =>
  readUserStore?.().currentUser?.role ?? null;

export const readUserStoreSnapshot = (): UserStoreSnapshot => ({
  currentUser: readUserStore?.().currentUser ?? null,
  impersonatedUserId: readUserStore?.().impersonatedUserId ?? null,
});
